import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { Phone } from '../../../assets/icons/Phone';
import { HybridButtonLabel, HybridFrame } from '../sections/hybrid';
import { LandingVariantProps } from './types';

/**
 * LP1 hybrid (`phone-only-v2`) — call-centre only, with the phone button
 * repeated after the benefits.
 *
 * Dials exactly what V1 dials (the variant copy reuses V1's `ctaPhoneLink`, and
 * falls back to the locale's base link like PhoneOnlyV1), and uses the same
 * button style as V1's phone button, so only the layout differs from V1.
 * The `**` on the first heading anchors the "** Hotline …" footnote.
 */
export const PhoneOnlyV2: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => {
  const phoneHref = copy.ctaPhoneLink ?? data.ctaPhoneLink;
  return (
    <HybridFrame
      data={data}
      copy={copy}
      cta={
        <div className="hyb-cta">
          <h2 className="hyb-cta-head">{`${copy.registration}**`}</h2>
          <ButtonLink
            leftIcon={Phone()}
            href={phoneHref}
            variant="primary"
            id="phone-cta"
            onClick={() => onCtaClick('phone', phoneHref)}
          >
            <HybridButtonLabel text={copy.ctaPhoneText} />
          </ButtonLink>
        </div>
      }
      repeatCta={
        <div className="hyb-cta hyb-cta-repeat">
          <h2 className="hyb-cta-head">{copy.repeatHeading}</h2>
          <ButtonLink
            leftIcon={Phone()}
            href={phoneHref}
            variant="primary"
            id="phone-cta-repeat"
            onClick={() => onCtaClick('phone', phoneHref)}
          >
            <HybridButtonLabel text={copy.ctaPhoneRepeatText ?? copy.ctaPhoneText} />
          </ButtonLink>
        </div>
      }
    />
  );
};
